import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";

const RoutingMachine = ({ points }) => {
    const map = useMap();

    const routingControlRef = useRef(null);

    useEffect(() => {

        if (!map) return;

        const control = L.Routing.control({
            waypoints: [],
            routeWhileDragging: false,
            show: false,
            addWaypoints: false,
            draggableWaypoints: false,
            fitSelectedRoutes: true,
            showAlternatives: false,
            lineOptions: {
                styles: [{ color: '#6FA1EC', weight: 4 }]
            },
            createMarker: function () { return null; }
        });

        control.addTo(map);
        routingControlRef.current = control;


        return () => {
            if (routingControlRef.current) {
                try {
                    map.removeControl(routingControlRef.current);

                } catch (error) {
                    console.warn("Blad podczas usuwania kontrolki routingu:", error);
                }
            }
        };
    }, [map]);

    useEffect(() => {
        if (!routingControlRef.current || !points) return;

        const waypoints = points.map(p => L.latLng(p.position[0], p.position[1]));
        routingControlRef.current.setWaypoints(waypoints);
    }, [points]);


    return null;
};

export default RoutingMachine;
